import React, { useState } from 'react';
import { HiOutlinePencilAlt, HiOutlineDownload, HiOutlineRefresh } from 'react-icons/hi';
import { toast } from 'react-toastify';

function CreatePhrase() {
  const [phrase, setPhrase] = useState('');
  const [fontSize, setFontSize] = useState(32);
  const [fontFamily, setFontFamily] = useState('Playfair Display');
  const [textColor, setTextColor] = useState('#3D2C2C');
  const [bgColor, setBgColor] = useState('#E8D5CC');
  
  const fonts = [
    'Playfair Display',
    'Inter',
    'Georgia',
    'Times New Roman',
    'Arial',
    'Verdana'
  ];
  
  const handleCopy = () => {
    navigator.clipboard.writeText(phrase);
    toast.success('Frase copiada!');
  };
  
  const handleDownload = () => {
    toast.info('Funcionalidade de download em breve!');
  };
  
  const handleClear = () => {
    setPhrase('');
    setFontSize(32);
    setFontFamily('Playfair Display');
    setTextColor('#3D2C2C');
    setBgColor('#E8D5CC');
  };
  
  return (
    <div className="create-phrase-page">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">
          <HiOutlinePencilAlt style={{ marginRight: '12px', verticalAlign: 'middle' }} />
          Criar frase
        </h1>
        <p className="page-subtitle">
          Crie frases personalizadas com fundo transparente para seus Stories.
        </p>
      </div>
      
      <div className="create-phrase-container">
        {/* Editor */}
        <div className="phrase-editor">
          <div className="form-group">
            <label className="form-label">Sua frase</label>
            <textarea
              className="phrase-input"
              placeholder="Digite sua frase aqui..."
              value={phrase}
              onChange={(e) => setPhrase(e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Tamanho da fonte</label>
            <input
              type="range"
              min="16"
              max="72"
              value={fontSize}
              onChange={(e) => setFontSize(parseInt(e.target.value))}
              style={{ width: '100%' }}
            />
            <span style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)' }}>
              {fontSize}px
            </span>
          </div>
          
          <div className="form-group">
            <label className="form-label">Fonte</label>
            <select
              className="form-select"
              value={fontFamily}
              onChange={(e) => setFontFamily(e.target.value)}
            >
              {fonts.map((font) => (
                <option key={font} value={font} style={{ fontFamily: font }}>
                  {font}
                </option>
              ))}
            </select>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div className="form-group">
              <label className="form-label">Cor do texto</label>
              <input
                type="color"
                value={textColor}
                onChange={(e) => setTextColor(e.target.value)}
                style={{ width: '100%', height: '40px', border: 'none', borderRadius: '8px' }}
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Cor de fundo</label>
              <input
                type="color"
                value={bgColor}
                onChange={(e) => setBgColor(e.target.value)}
                style={{ width: '100%', height: '40px', border: 'none', borderRadius: '8px' }}
              />
            </div>
          </div>
          
          <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
            <button className="btn btn-primary" onClick={handleCopy}>
              Copiar Frase
            </button>
            <button className="btn btn-outline" onClick={handleDownload}>
              <HiOutlineDownload />
              Baixar PNG
            </button>
            <button className="btn btn-outline" onClick={handleClear}>
              <HiOutlineRefresh />
              Limpar
            </button>
          </div>
        </div>
        
        {/* Preview */}
        <div className="phrase-preview">
          <h3 style={{ 
            marginBottom: '16px', 
            fontFamily: "'Playfair Display', serif",
            color: 'var(--color-text-primary)'
          }}>
            Pré-visualização
          </h3>
          <div 
            className="phrase-preview-text"
            style={{
              fontSize: `${fontSize}px`,
              fontFamily: fontFamily,
              color: textColor,
              backgroundColor: bgColor,
              minHeight: '300px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '12px',
              padding: '24px',
              wordBreak: 'break-word'
            }}
          >
            {phrase || 'Sua frase aparecerá aqui...'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatePhrase;
